module.exports = __webpack_public_path__ + "img/uob.cf286c68.png";